import React from 'react';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import AboutUs from './AboutUs';

const AboutUsPage = () => {
  return (
    <Box>
      <Container>
        <AboutUs />
      </Container>
    </Box>
  );
};

export default AboutUsPage;
